import styled from 'styled-components'

export interface GuestLayoutSCProps {}

export const GuestLayoutSC = styled.div<GuestLayoutSCProps>`
  height: 100%;
  background: url('/assets/login-banner.png') no-repeat center right;
  background-color: ${({ theme }) => theme.colors.text.hightlightPrimary};
  background-size: 700px 800px;
  background-position: bottom right;

  .content {
    display: inline-block;
    margin: 80px 0 60px 112px;
    width: 406px;
  }
`
